import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import * as firebase from 'firebase/app';
import { BehaviorSubject } from 'rxjs';
@Injectable()
export class LogisticsService {
  shipments:any;
  private messageSource = new BehaviorSubject('');
  currency = this.messageSource.asObservable();
  constructor(private db:AngularFireDatabase) { 
    if(localStorage.getItem("courierapp_role") == "super admin")
    {
      this.shipments = this.db.list("shipments");
    }
    else
    {
      this.shipments = this.db.list("shipments", ref=> ref.orderByChild("branch").equalTo(localStorage.getItem('branch')));
    }
    this.getSettings();
  }
getShipments()
{
  return this.shipments;
}
getDrivers()
{
  return  this.db.list('users',ref => ref.orderByChild('role').equalTo("driver"));
}
getBranch()
{
  return  this.db.list('branches',ref => ref.orderByChild('status').equalTo("active"));
}
getSupervisors()
{
  return this.db.list('users',ref => ref.orderByChild('role').equalTo("supervisor"));
}
acceptOrder(id)
{
  firebase.database().ref("shipments").child(id).update({
    status: 1 
  });
}
declineOrder(id)
{
  firebase.database().ref("shipments").child(id).update({
    status: 2 
  });
}
assignToBranch(shipmentId, selectedBranch, status)
{
  if(status == 11)
  {
    firebase.database().ref("shipments").child(shipmentId).child("branch").set(selectedBranch);
  }
  else{
    firebase.database().ref("shipments").child(shipmentId).child("branch").set(selectedBranch).then(()=>{
      firebase.database().ref("shipments").child(shipmentId).child("assignedTo").remove();
      firebase.database().ref("shipments").child(shipmentId).child("status").set(1);
    });
  }
}
assignDeliveryBoy(id,selectedPerson,branch,today,time,status,role)
{
  firebase.database().ref("users").child(selectedPerson).once("value",(deliveryBoy)=>{
    if(deliveryBoy.child("status").val() == "1" && deliveryBoy.child("branch").val() == branch)
    {
    firebase.database().ref("shipments").child(id).update({
      assignedToDB: selectedPerson,
      assignedPerson: deliveryBoy.child("name").val(),
      status: status,
      assignedTo: selectedPerson,
      branch: branch
    }).then(()=>{
      firebase.database().ref("users").child(selectedPerson).child("assignedOrders").child(id).update({
        id : id,
        status: status,
        assignedBy: localStorage.getItem("courierapp_user_id")
      }).then(()=>{
        var data = {
          status : status,
          assignedTo : selectedPerson,
          role : role,
          assignedPerson : deliveryBoy.child("name").val()
        }
        firebase.database().ref("shipments").child(id).child("assignedHistory").push(data).then(()=>{
          var transitHistoryData = {
            branch: branch,
            date: today,
            time: time,
            status : "Order Assigned",
            userId : selectedPerson,
            userName : deliveryBoy.child("name").val()
            }
            firebase.database().ref("shipments").child(id).child("transitHistory").push(transitHistoryData).then(()=>{
              
            });
        });
      });;
    });
  }
});
  }
  deleteShipment(id)
  {
    this.db.object('/shipments/'+id).remove();
  }
  transferOrder(branch,shipmentId,user,shipmentBranch,date_time)
  {
    var data = {
      branch : branch,
      status : 11
    }
    firebase.database().ref("shipments").child(shipmentId).update(data);
    var branchTransferHistory = {
      from: shipmentBranch,
      to: branch,
      admin : localStorage.getItem("courierapp_user_id"),
      date: date_time.date,
      time: date_time.time,
      shipmentId: shipmentId,
      status: "Branch Transfer",
      userName: user.name
    }
    firebase.database().ref("branchTransferHistory").push(branchTransferHistory);
    firebase.database().ref("shipments").child(shipmentId).child("transitHistory").push(branchTransferHistory);
    firebase.database().ref("shipments").child(shipmentId).child("items").once("value").then((data)=>{
      
      var items = data.val();
      //console.log("data",items);
      var itemsList = [];
      for(let i in items)
      {
        var y = items[i];
        //console.log("y",y);
        y["barcodeScannedStatus"] = "transfer";
        var barcodes = items[i].barcodes;
        var barcodeList = [];
        for(let i in barcodes)
        {
          var barcode = barcodes[i];
          barcode["scannedStatus"] = "transfer";
          barcodeList.push(barcode);
        }
        y["barcodes"] = barcodeList;
        itemsList.push(y);
      }
      firebase.database().ref("shipments").child(shipmentId).child("items").update(itemsList);
    });
  }
  outForDeliveryAssignDeliveryBoy(shipmentId)
  {
    //console.log("outForDelivery",shipmentId);
    firebase.database().ref("shipments").child(shipmentId).child("outForDelivery").set(true);
  }
  getSettings()
     {
      firebase.database().ref("settings").child("general").on("value",(generalSetting)=>{
        var currency =  generalSetting.child('currency').val();
        //console.log("currency",currency);
        this.messageSource.next(currency);
      });
     }
     getBranchName(id)
     {
      return firebase.database().ref("branches").child(id);
     }
     getBranchAll()
    {
      return  this.db.list('branches');
    }
    getAllCities()
    {
      return  this.db.list("cities");
    }
    getNewlyArrivedShipments()
    {
      return firebase.database().ref("shipments").orderByChild("notif").equalTo("unread");
    }
    getAllShipmentsAssignedTobranch(branchId)
    {
      return firebase.database().ref("shipments").orderByChild("branch").equalTo(branchId);
    }
    getBranchTransfferedOrders(branch)
    {
      return firebase.database().ref("branchTransferHistory").orderByChild("from").equalTo(branch);
    }
    getShipmentsWithId(id)
    {
      return firebase.database().ref("shipments").child(id);
    }
}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/logistics-operations/shared/logistics.service.ts